"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const action = __importStar(require("./header/action"));
exports.action = action;
const style = __importStar(require("./header/style"));
exports.style = style;
const type = __importStar(require("./header/type"));
exports.type = type;
